import { CrecaAggregateStatusApi } from "@/features/accounts/creca/services/creacaaggregate-status-api";
import { GetCrecaAggregateStatusRequestModel } from "@/features/accounts/creca/services/crecaaggregate-status-model";

/// アグリゲーション状態取得処理
export class CrecaAggregateStatusService {
    private aggregateStatusApi = new CrecaAggregateStatusApi();

    /**
    * アグリゲーション状態取得API実行
    */
    public async getAggregateStatus(param: GetCrecaAggregateStatusRequestModel) {
        return await this.aggregateStatusApi.getAggregateStatus(param);
    }
}
